import React, {useCallback} from "react";
import {useForm} from "react-hook-form";
import {Subject} from "rxjs";
import {showToast} from "common";
import {useObservable} from "rxsupport";
import {ReportModal} from "../../form-components/ReportModal";
import {AuthorizationInfo, NoContactInput} from "../../domain";
import {NoContactForm} from "./NoContactForm";
import {useLatestNoContactInput} from "./useLatestNoContactInput";

type Props = {
    visible$: Subject<boolean>;
    authorization: AuthorizationInfo;
    onFinished: (formValues: NoContactInput | null) => Promise<void>;
};

export function NoContactFormAuthModal({authorization, visible$, onFinished}: Props) {
    const visible = useObservable(visible$, false);

    const methods = useForm<NoContactInput>({
        defaultValues: {
            numberOfContactAttempts: '',
            initialTypeOfContact: '',
            typeOfContact: '',
            comments: '',
        }
    });

    const onCancel = useCallback(async () => {
        showToast.warning(`Submission for No Contact is cancelled`);
        methods.reset();
        visible$.next(false);
    }, [methods, visible$]);

    const {isRunning$} = useLatestNoContactInput(visible, methods, authorization.guid);
    const loading = useObservable(isRunning$, false);

    return (
        <ReportModal visible={visible} title={'No Contact'} onClose={onCancel}>
            <NoContactForm visible$={visible$}
                           methods={methods}
                           onFinished={onFinished}
                           onCancel={onCancel}
                           externalLoading={loading}
                           authorizationGuid={authorization.guid}/>
        </ReportModal>
    );
}
